import script from "./main02Swiper.vue?vue&type=script&setup=true&name=main02Swiper&lang=js"
export * from "./main02Swiper.vue?vue&type=script&setup=true&name=main02Swiper&lang=js"

const __exports__ = script;

export default __exports__